import React, { Component } from 'react';
import { Modal, Steps, Button, message } from 'antd';
const Step = Steps.Step;

class TicketModal extends Component {
  constructor(props) {
    super(props);
    this.steps = {step0: {titile: false, body: false}};
    this.state = {step: 0, stepLimit: 0, stepValidation: this.steps, ticket: {}};
    this.handleNext = this.handleNext.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.showStep = this.showStep.bind(this);
    // Input values
    this.handleTitle = this.handleTitle.bind(this);
    this.handleBody = this.handleBody.bind(this);
    this.setProp = this.setProp.bind(this);
  }

  handleNext() {
    if(!this.validateStep)
      return message.warning('Necesitas llenar los campos obligatorios')

    if(this.state.step === this.state.stepLimit) {
      this.props.handleSave(this.state.ticket);
      this.setState({validation: true, step: 0, ticket: {}});
    } else {
      this.setState({step: this.state.step + 1});
    }
  }

  handleBack() {
    if(this.state.step === 0) {
      this.props.handleClose();
    } else {
      this.setState({step: this.state.step - 1});
    }
  }

  validateStep() {
    let steps = 0;
    let total = 0;
    for(let item in this.state.stepValidation[`step${this.state.step}`]) {
      if(this.state.stepValidation[`step${this.state.step}`][item]) {
        steps += 1;
      }
      total += 1;
    }
    
    if(steps === total) {
      return true;
    } else {
      return false;
    }
  }

  handleTitle(event) {
    this.setProp('titile', event.target.value);
    this.setState({validation: true});
  }

  handleBody(event) {
    this.setProp('body', event.target.value);
    this.setState({validation: true});
  }

  setProp(prop, value) {
    let ticket = this.state.ticket;
    let validation = this.state.stepValidation;
    ticket[prop] = value;
    
    // Update validation
    if(String(value).length > 0) {
      validation[`step${this.state.step}`][prop] = true;
    } else {
      validation[`step${this.state.step}`][prop] = false;
    }
    
    this.setState({ticket: ticket, stepValidation: validation});
  }

  showStep(step) {
    if(step === this.state.step) {
      return 'block';
    } else {
      return 'none';
    }
  }

  render() {
    // Render component
    return (
      <Modal
        title={this.props.title}
        visible={this.props.visible}
        onCancel={this.props.handleClose}
        width={800}
        footer={null}
        destroyOnClose={true}
      >
        <div className="row" style={{ padding: '0px 30px' }}>
          <Steps size="small" current={this.state.step}>
            <Step title="Problema" />
            <Step title="Finalizar" />
          </Steps>
        </div>

        <br/> <br/>

        <div className="row" style={{ padding: '0px 30px' }}>
          {/* Step 1 */}
          <div style={{ width: '100%', display: this.showStep(0) }}>
            <div className="form-group">
              <label>¿Qué es lo que sucede?</label>
              <input type="text" className="form-control" defaultValue={this.props.current.titile} placeholder="Tengo una duda con.." onChange={this.handleTitle} />
            </div>

            <div className="form-group">
              <label>Escribe un poco más la situación</label>
              <input type="text" className="form-control" defaultValue={this.props.current.body} placeholder="Paso cuando..." onChange={this.handleBody} />
            </div>
          </div>
        </div>

        <br/><hr/>

        <div className="form-group text-center">
          <Button type="dashed" style={{ marginRight: '10px' }} onClick={this.handleBack}>Atras</Button>
          <Button type="primary" onClick={this.handleNext}>Siguiente</Button>
        </div>
      </Modal>
    );
  }
}

export default TicketModal;



// WEBPACK FOOTER //
// ./src/components/modals/public/TicketModal.js